import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";
import "hammerjs";

import { ServiceWorkerModule } from "@angular/service-worker";
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from "@fuse/components";
import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";
import { AppComponent } from "app/app.component";
import { fuseConfig } from "app/fuse-config";
import { HomeModule } from "app/home/home.module";
import { LayoutModule } from "app/layout/layout.module";
// import { NgxHorizontalTimelineModule } from 'ngx-horizontal-timeline';
import { MatPaginatorIntl } from "@angular/material/paginator";
import { appRoutes } from "./app.routing";
import { AppsModule } from "./apps/apps.module";
import { AuthHandlerComponent } from './auth-handler/auth-handler.component';
import { BaseModule } from "./base-module/base.module";
import { NotificacaoModule } from "./notificacao/notificacao.module";
import { ParametrosModule } from "./parametros/parametros.module";
import { AuthInterceptor } from "./shared/interceptors/auth.interceptor";
import { SentryHttpInterceptor } from "./shared/interceptors/sentry-http.interceptor";
import { getPaginatorIntl } from "./shared/paginator-intl-pt";
import { SsoInitComponent } from './sso-init/sso-init.component';

@NgModule({
    declarations: [AppComponent, AuthHandlerComponent, SsoInitComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),
        // Material moment date module
        // MatMomentDateModule,
        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        HomeModule,
        BaseModule,
        AppsModule,
        NotificacaoModule,
        ParametrosModule,
        ServiceWorkerModule.register("ngsw-worker.js", { enabled: true }),
        // NgxHorizontalTimelineModule
    ],
    providers: [
        { provide: MatPaginatorIntl, useFactory: getPaginatorIntl },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => Promise.resolve(true), // Força a inicialização do Sentry
            deps: [Sentry.TraceService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SentryHttpInterceptor,
            multi: true,
        },
        {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
